"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";

/**
 * Shares the singleton PostHog client (initialised in instrumentation-client.ts)
 * via React context so components can call `usePostHog()`. Pageviews, replay,
 * and exception autocapture all run from the singleton — this provider does not
 * gate them, so it is safe to mount even before init completes / when the key
 * is absent (every posthog.* call no-ops).
 */
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return <PHProvider client={posthog}>{children}</PHProvider>;
}
